import { createSelector } from 'reselect'
import hasFullSizeItemsCartSelect from 'modules/cart/redux/selectors/has-full-size-items'
import hasGiftCardCartSelect from 'modules/cart/redux/selectors/has-gift-card'
import hasExpressCheckoutCartSelectUtil from 'modules/cart/redux/selectors/has-express-checkout/utils'
import hasReachedCheckoutMinimumCartSelect from 'modules/cart/redux/selectors/has-reached-checkout-minimum'
import isMixedCollectionUrlLocationUtil from 'utils/location/is-mixed-collection-url'

const hasExpressCheckoutCartSelect = createSelector(
  hasFullSizeItemsCartSelect,
  hasGiftCardCartSelect,
  hasReachedCheckoutMinimumCartSelect,
  (
    hasFullSizeItems,
    hasGiftCard,
    hasReachedCheckoutMinimum
  ) => {
    return hasExpressCheckoutCartSelectUtil({
      hasFullSizeItems,
      hasGiftCard,
      hasReachedCheckoutMinimum,
      isMixedCollectionUrl: isMixedCollectionUrlLocationUtil()
    })
  }
)

export default hasExpressCheckoutCartSelect
